export default __webpack_public_path__ + "static/media/home-consulting-about-bg.2f42a94d.jpg";